import { useState, useRef } from "react";
import { ChevronRightIcon } from '@heroicons/react/24/outline';

export default function FormationMenu({sections}) {
  const [openIndex, setOpenIndex] = useState(null);
  const contentRefs = useRef([]); // Store refs for height calculation

  const toggleSection = (index) => {
    setOpenIndex(openIndex === index ? null : index); 
  };

  return (
    <div className=" w-[90vw] mx-0 undi:w-[75vw] undi:mx-14 my-10 space-y-2">
      {sections.map((section, index) => (
        <div key={index} className="border-none border-b-2 border-gray-300 rounded-lg shadow-sm w-full">
          {/* Button Header */}
          <button
            className="w-full text-left px-4 py-3 font-semibold hover:bg-gray-100 transition-all flex items-center"
            onClick={() => toggleSection(index)}
          >
            <ChevronRightIcon className="undi:h-4 h-4 text-black lg:ml-4 ml-1 stroke-[2px]" /> {section.title}
          </button>

          {/* Content Wrapper with Dynamic Height */}
          <div
            ref={(el) => (contentRefs.current[index] = el)}
            className="overflow-hidden transition-[height] duration-300 ease-in-out"
            style={{
              height: openIndex === index ? `${contentRefs.current[index]?.scrollHeight}px` : "0px",
            }}
          >
                <div className="py-4">
                    {section.content.split('\n').map((line, i) => (
                        <p key={i}className="px-10 text-gray-700">{line}</p>
                    ))}
                </div>
          </div>
        </div>
      ))}
    </div>
  );
}
